(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guardian-delivery-expectation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-guardian-delivery-expectation]').forEach((element)=>{
  if(element.dataset.measured)return
  element.dataset.measured='true'
  const detail={event:'guardian_delivery_expectation_viewed',delivery_class:element.dataset.deliveryClass,context:element.dataset.context,locale:document.documentElement.lang||'en'}
  window.dispatchEvent(new CustomEvent('guardian:delivery',{detail}))
  if(Array.isArray(window.dataLayer))window.dataLayer.push(detail)
})
  } catch(e) { console.error(e); }
})();

})();
